// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_aq-b";
export var colorBlue = "_aq-8";
export var colorDot = "_aq-0";
export var colorDotLarge = "_aq-2";
export var colorDotSmall = "_aq-1";
export var colorGreen = "_aq-7";
export var colorGrey = "_aq-3";
export var colorOrange = "_aq-5";
export var colorPink = "_aq-a";
export var colorPurple = "_aq-9";
export var colorRed = "_aq-4";
export var colorYellow = "_aq-6";